import SimpleLightbox from "simplelightbox/dist/simple-lightbox.esm";

export default function(root) {
	let rel = []
	let lightboxSelector = '.lightbox[rel]'

	Array.from(root.querySelectorAll(lightboxSelector))
		.forEach((node) => {
			let relSelector = node.getAttribute('rel')

			if(typeof rel[relSelector] === "undefined") {
				rel[relSelector] = new SimpleLightbox(lightboxSelector, {
					rel: relSelector,
					history: false
				})
			}
		})
}
